import React, { Component } from 'react';

import { View } from '@dbk/ui-react-utils';
import Text from '@dbk/ui-text';

import LegendHeader from './legend-header';

import {
  renderItem as renderCircleLegendItem,
  renderItems as renderItemsHof,
  propTypes,
  defaultProps
} from './legend.common';

import './legend.css';

class PortfolioChartLegend extends Component {
  static defaultProps = {
    ...defaultProps,
  };

  static propTypes = {
    ...propTypes
  };

  renderItem({ color, name, id }) {
    return (
      <View key={id} className="chart-legend__item">
        {renderCircleLegendItem(color)}
        <Text>{name}</Text>
      </View>
    )
  }

  render() {
    const { items, showLegend, toggleLegend, messages, channel } = this.props;
    const renderItemsWithItemRenderer = renderItemsHof(this.renderItem);
    return (
      <View className="chart-legend">
      {channel !== "WEB" ? <LegendHeader
          messages={messages}
          toggleLegend={toggleLegend}
          showLegend={showLegend}
          channel={channel}
        />: null}
        
        {showLegend &&
        <View className="chart-legend__body">
          {renderItemsWithItemRenderer(items)}
        </View>}
      </View>
    )
  }
}

export default PortfolioChartLegend;